<template>
  <div class="grid-container">
    <div
      class="grid-item"
      :class="{ disabled: !flight.isActive }"
      v-for="flight in flights"
      :key="flight.id"
      @click="navigateToListing(flight.id)"
    >
      <div class="flight-content">
        <div class="image-container">
          <img
            :src="
              flight.bannerUrl ||
              require(`@/assets/placeholder-image-listing.png`)
            "
            alt="Flight Image"
            class="flight-image"
          />
        </div>
        <div class="flight-details">
          <div class="flight-header">
            <h4>{{ getTruncatedDescription(flight.location, 15) }}</h4>
            <h2>{{ flight.title }}</h2>
            <hr class="line-divider" />
          </div>

          <div class="flight-info">
            <p>{{ getTruncatedDescription(flight.description, 100) }}</p>
          </div>

          <div class="flight-footer">
            <div class="price-container">
              <span>30 min · Private Live Tour</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { truncateText } from "@/utils/helper";

export default {
  name: "GridMobile",
  props: {
    flights: {
      type: Array,
      required: true,
    },
    guestLabel: {
      type: String,
      default: "guest",
    },
  },
  methods: {
    getTruncatedDescription(description, maxLength) {
      return truncateText(description, maxLength);
    },
    navigateToListing(listingId) {
      this.$router.push({
        path: `/listing`,
        query: { listingId: listingId },
      });
    },
  },
};
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 20px;
  padding: 3rem 0rem;
  margin-bottom: 5rem;
  width: 100%;
}

.grid-item {
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
}

.grid-item.disabled {
}

.flight-content {
  display: flex;
  max-height: 250px;
  flex-direction: row;
}

.image-container {
  position: relative;
}

.flight-image {
  width: 170px;
  height: 250px;
  border-radius: 8px;
  object-fit: cover;
}

.flight-details {
  flex: 1;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.flight-details h4 {
  font-size: 0.8rem;
  color: #666;
  margin-bottom: 5px;
}

.flight-details h2 {
  font-size: 1.5rem;
  color: #333;
}

.flight-details p {
  font-size: 0.8rem;
  color: #666;
}

.flight-header {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-bottom: 0.5rem;
}

.flight-header h2 {
  margin-bottom: 0.5rem;
}

.flight-info {
  display: flex;
  flex: 2.5;
  flex-direction: column;
  justify-content: space-between;
}

.flight-footer {
  display: flex;
  flex: 0.5;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
}

.flight-footer p {
  font-size: 1rem;
  color: #000 !important;
}

.flight-footer span {
  font-size: 0.8rem;
  color: #949494;
}

.price-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
}

.line-divider {
  border: none;
  border-top: 1px solid #e6e4e4;
}
</style>
